import * as React from "react";
import styled from "@mui/material/styles/styled";
import ListItem from "@mui/material/ListItem";
import { DataInputSectionConfigurations } from "../config/dataInputSectionConfiguration";
import ListItemText from "@mui/material/ListItemText/ListItemText";
import {
  CONDENSED_FONT,
  CondensedTypography,
} from "fe-web-components/styles/typography";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import CheckIcon from "@mui/icons-material/Check";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { ActionButton } from "fe-common/ui/buttons/actionButton";
import { MobileOnly } from "../util/mobileOnly";

//region [[ Styles ]]

const PatientChartSubGroupTitleView = styled(ListItem)(({ theme }) => ({
  paddingTop: "0",
  marginBottom: "10px",
  [theme.breakpoints.down(MobileView)]: {
    marginBottom: "0px",
    borderBottom: "1px solid " + KahunColorMap.Divider,
    height: "45px",
    paddingLeft: "0px",
    paddingRight: "0px",
  },

  "& .action-button": {
    borderRadius: "5px",
    padding: 0,
    height: "22px",
    fontSize: "12px",
  },
}));

const CategoryText = styled(ListItemText)(({ theme }) => ({}));

const TitleText = styled("div")(({ theme }) => ({}));

const CheckIconStyled = styled(CheckIcon)({
  fontSize: "16px",
  marginTop: "4px",
  marginLeft: "8px",
  color: "green",
});

const CategoryTypography = styled(CondensedTypography)(({ theme }) => ({
  fontSize: "17px",
  fontWeight: 500,
  fontFamily: CONDENSED_FONT,
  display: "flex",
  color: RosebudColorMap.green2,
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "14px",
    fontWeight: 500,
    color: KahunColorMap.DefaultLight,
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartSubGroupTitleProps {
  subGroupId: string;
  section: PatientCaseGrouping;
  gotoDataInput: (section, subgroupId) => void;
  showCheck?: boolean;
  element?: any;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartSubGroupTitle = ({
  ...props
}: PatientChartSubGroupTitleProps) => {
  return (
    <PatientChartSubGroupTitleView
      dense={true}
      key={props.subGroupId}
      onClick={() => props.gotoDataInput(props.section, props.subGroupId)}
    >
      <CategoryText
        primary={
          <CategoryTypography>
            <TitleText>
              {DataInputSectionConfigurations[props.subGroupId].displayName}
            </TitleText>
            {props.showCheck === true && <CheckIconStyled />}
          </CategoryTypography>
        }
      />
      {props.element}

      <MobileOnly>
        <ActionButton
          className={"action-button"}
          onClick={() => props.gotoDataInput(props.section, props.subGroupId)}
          label={"Add"}
          primary={"true"}
        />
      </MobileOnly>
    </PatientChartSubGroupTitleView>
  );
};
